import { render, staticRenderFns } from "./OutNotification.vue?vue&type=template&id=bb532768"
import script from "./OutNotification.vue?vue&type=script&lang=js"
export * from "./OutNotification.vue?vue&type=script&lang=js"
import style0 from "./OutNotification.vue?vue&type=style&index=0&id=bb532768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports